$(document).ready(function(){
  function addToCartSuccess() {
    $.get( "/cart?view=mini", function( data ) {
      $('#crt').html(data);
      $('#crt').removeClass('loading');
      if(jQuery('[name=currencies]').length) {
        Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
      }
    });
  }
  function refreshCart(cart) {
    $('.cart-count').text(cart.item_count);
  }

  $('body').on('click','.buttonAddtoCart',function(e){
    e.preventDefault();
    var btn = $(this);
    var form = $(this).closest('form');
    btn.attr('disabled', 'disabled');
    btn.text('adding...');
    form.find('.error').remove();

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: form.serialize(),
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        form.append('<p class="error">'+response.description+'</p>').find('.error').fadeIn().delay(4000).fadeOut();
        btn.text('add to cart');
        btn.removeAttr('disabled');
      }
    }).done(function( data ) {
      addToCartSuccess();
      btn.text('add to cart');
      btn.removeAttr('disabled');
      $.getJSON('/cart.js', function(cart){
        refreshCart(cart);
      });
      $('.productGrid .productItem').removeClass('qvopen');
      $('body').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');
    });

  });

  $('body').on('click','.fullPage.witmenu, .closemenu, .closecart', function(e){
    e.preventDefault();
    $('body').removeClass('menuOpen');
    $('.fullPage').removeClass('witmenu');
    $('body').removeClass('cartOpen');
  });
  $('.cart_button').on('click',function(e){
    e.preventDefault();
    setTimeout(function(){
      $('body').addClass('cartOpen');
      $('.fullPage').addClass('witmenu');
    }, 50);
  });
  $('body').on('click', '.adjust',function(){
    var input = $(this).parent().find('input');
    var ip = parseInt(input.val());
    if($(this).hasClass('plus')) {
      ip = ip + 1;
    } else {
      ip = ip - 1;
    }
    if(ip==0) {
      return false;
    }
    input.val(ip);

    $('#crt').addClass('loading');
    var id = parseInt(input.attr('data-id'));
    $.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates['+id+']='+ip,
      dataType: 'json',
      error: function(jqXHR, textStatus, errorThrown){
        var response = $.parseJSON(jqXHR.responseText);
        alert(response.description);
        $('#crt').removeClass('loading');
      }
    }).done(function( data ) {
      addToCartSuccess();
      $.getJSON("/cart.js", function(cart) {
        refreshCart(cart);
      });
      $('#crt').removeClass('loading');
    });

  });
  $("#crt").on('click', "a.remove_item", function(r){
    $('#crt').addClass('loading');
    r.preventDefault();
    var id = $(this).data("id");
    Shopify.changeItem(id,0, function(c){
      $('.itemCount').text(c.item_count);
      if(!c.item_count) {
        $('#crt').empty();
        $('#crt').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');
        $('#crt').removeClass('has-item');
        $('#crt').removeClass('loading');
        $.getJSON("/cart.js", function(cart) {
          refreshCart(cart);
        });
      } else {
        addToCartSuccess();
      }
    });
    $.getJSON("/cart.js", function(cart) {
      refreshCart(cart);
    });
  });

  $('.toggleItem').on('click',function(e){
    //var text = $(this).class() == 'fa-angle-right' ? 'fa-angle-down' : 'fa-angle-right';
    $(this).find('i').toggleClass('fa-angle-right').toggleClass('fa-angle-down');
    $(this).parent().next('ul').slideToggle();
    $(this).parent().toggleClass('activetoggle');
  });
  $('.mobileNav > button').click(function(e) {
    setTimeout(function(){
      $('body').addClass('menuOpen');
      $('.fullPage').addClass('witmenu');
    }, 50);
  });

  $('.main-banner').slick({
    dots:true,
    arrows: false,
    infinite:true,
    slidesToShow:1,
    slidesToScroll:1,
    /*fade: true,*/
    cssEase: 'linear',
    autoplay:true,
    autoplaySpeed:3000,
  });
  $('#leading-categories ul').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay:true,
    arrows:true,
    responsive: [
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 2,
          autoplay: true
        }
      }
    ]
  });
  $('.usp-bar ul').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows:false,
    responsive: [
      {
        breakpoint: 1105,
        settings: {
          slidesToShow: 2,
          autoplay: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $('.trending-now ul1').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $('.productSlider1, .trending-now ul').slick({
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  });
  $('.relatedproductGrid .grid--uniform').slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows:true,
    responsive: [
      {
        breakpoint: 1025,
        settings: {
          slidesToShow: 4,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });

  var $slider = $(".recently-viewed-products");
  $slider.on('init', function(event, slick) {
    setTimeout(function() {
      $slider.find('.slick-dots').addClass('');
    }, 100);
  });
  if ($(window).width() < 767) {
    $('.recently-viewed-products').slick({
      infinite: false,
      arrows:true,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  }
  else {
    $slider.slick({
      infinite: false,
      slidesToShow: 6,
      slidesToScroll: 1,
      arrows:true,
      responsive: [
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2
          }
        }
      ]
    });
  }


  $(".product-tabing-col h2").on('click', function(e) {
    e.preventDefault();
    $slider.slick('refresh');

  });

  $slider.on('reInit', function(event, slick) {
    console.log('reinitalized');
  });


  var stickyBottomOffset = $('.main-footer').height();
  var stickyTopOffset = $('.header').height();
  $(".header").sticky({topSpacing:0, zIndex: 100});
  if ($(window).width() < 990) {
    $(".collection .sticky-content").sticky({topSpacing:80});
  }


  //   $('.main-filter-btn a').click(function(e){
  //     e.preventDefault();
  //     $('.mob-filder-toggle').slideToggle();
  //   });
  $('.main_title a').click(function(e){
    e.preventDefault();
    $('.all_filter').slideToggle();
  });
  $('.list-style-links .grid1').click(function(e){
    e.preventDefault();
    $('.list-style-links li').removeClass("active");
    $(this).addClass("active");
    $('#bc-sf-filter-products .grid__item').addClass("four-twelfths");
    $('#bc-sf-filter-products .grid__item').addClass("medium-up--four-twelfths");
    $('#bc-sf-filter-products .grid__item').removeClass("three-twelfths");
    $('#bc-sf-filter-products .grid__item').removeClass("medium-up--three-twelfths");
  });

  $('.list-style-links .grid2').click(function(e){
    e.preventDefault();
    $('.list-style-links li').removeClass("active");
    $(this).addClass("active");
    $('#bc-sf-filter-products .grid__item').removeClass("four-twelfths");
    $('#bc-sf-filter-products .grid__item').removeClass("medium-up--four-twelfths");
    $('#bc-sf-filter-products .grid__item').addClass("three-twelfths");
    $('#bc-sf-filter-products .grid__item').addClass("medium-up--three-twelfths");
  });



  $('.featured-image').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.product-thumbnails',
    dots:false
  });
  $('.product-thumbnails').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.featured-image',
    dots: false,
    infinite: false,
    focusOnSelect: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3
        }
      }
    ]
  });


  function closePopup() {
    $('.popupBox').removeClass('slideInDown');
    $('.popupBox').addClass('slideOutUp');
    $('.popupOverlay').fadeOut('slow');
  }
  function openPopup(a) {
    $('.popupBox').addClass('slideInDown');
    $('.popupBox').removeClass('slideOutUp');
    $('.popupOverlay.'+a).fadeIn('slow');
  }
  $('body').on('click','.popupinfo',function(e){
    e.preventDefault();
    var id = $(this).data('href');
    openPopup(id);
  });
  $('body').on('click','.cls_popup',function(e){
    e.preventDefault();
    closePopup();
  });
  $(document).keyup(function(e) {
    if (e.keyCode == 27) { 
      closePopup();
    }
  });
  window.onclick = function(e) {
    if ($(e.target).hasClass('popupOverlay')) {
      closePopup();
    }
    if (!$(e.target).closest('.mobilecolNav').is('.mobilecolNav')) {
      $('.searchMobile').removeClass('openSearch');
    }
  }

  $('.searchMobile a').click(function() {
    $(this).parent('.searchMobile').toggleClass('openSearch');
    $(this).parent('.searchMobile').find('input').focus();
  });

  $('.footer-nav-menu .link-list h2').click(function(){
    $(this).next('ul').slideToggle();
    $(this).toggleClass('activefNav');
  });

  $('.accordion').accordion({
    defaultOpen: 'section1',
    cookieName: 'accordion_nav',
    speed: 200
  });

  $(function() {
    $('.qtyplus').click(function(e){
      e.preventDefault();
      fieldName = $(this).attr('field');
      var currentVal = parseInt($('input[id='+fieldName+']').val());
      if (!isNaN(currentVal)) {
        $('input[id='+fieldName+']').val(currentVal + 1);
      } else {
        $('input[id='+fieldName+']').val(0);
      }
      $('.cart__update-btn').trigger('click');
    });
    $(".qtyminus").click(function(e) {
      e.preventDefault();
      fieldName = $(this).attr('field');
      var currentVal = parseInt($('input[id='+fieldName+']').val());
      if (!isNaN(currentVal) && currentVal > 1) {
        $('input[id='+fieldName+']').val(currentVal - 1);
      } else {
        //$('input[id='+fieldName+']').val(1);
      }
      $('.cart__update-btn').trigger('click');
    });

  });

  $(".Sub-Title > a").click(function(e){
    e.preventDefault();
    if($(this).hasClass('openfilter')){
      $(this).next(".Filter-title ul").slideUp(300);
      $(this).removeClass('openfilter');
    }else{
      $(".Sub-Title > a").removeClass('openfilter');
      $(".Sub-Title > ul ").slideUp(500);
      $(this).next(".Filter-title ul").slideToggle(300);
      $(this).toggleClass('openfilter');
    }
  });

  /* $('.Filter-title').each(function(){
    if($(this).find('.filterTagActive').length) {
      $(this).find('.filterToggle').addClass('openfilter');
      $(this).find('ul').show();
    }
  });*/

  $('.Product-Head-cols .product-tabing-col h2').click(function(){
    var tab_id = $(this).attr('data-tab');

    $('.Product-Head-cols .product-tabing-col h2').removeClass('active');
    $('.tab-content').removeClass('active');

    $(this).addClass('active');
    $("#"+tab_id).addClass('active');
  });




  /* Quick VIew */
  $('.openQv').on('click', function(e){
    $(this).attr('disabled','disabled');
    $('.qvProduct').removeAttr('style');
    var url = $(this).attr("href");
    e.preventDefault();
    $.get( url, function( data ) {
      $('#qvProductContent').html(data);
      openPopup('qvPopup');
      Currency.convertAll(shopCurrency, jQuery('[name=currencies]').val());
      $('.puList').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: false
      });

      $('.qv_main').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.qv_thumb'
      });
      $('.qv_thumb').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.qv_main',
        dots: false,
        focusOnSelect: true,
        arrows: true,
      });

      $('.addtocartForm').on('submit', function(e){
        e.preventDefault();
        $('#AddToCart').attr('disabled');
        $('#AddToCart span').text('Adding..');
        var form = $(this);
        $('.puadd:checked').each(function(){
          var id = $(this).attr('data-id');
          $.ajax({
            url: '/cart/add.js',
            data: { id: id },
            type: 'POST',
            dataType: 'json',
            async:false
          });
        });
        $.ajax({
          url: '/cart/add.js',
          data: form.serialize(),
          type: 'POST',
          dataType: 'json',
          async:false,
          success: function(){
            $('#AddToCart').removeAttr('disabled');
            $('#AddToCart span').text('Added.');
            closePopup();
            addToCartSuccess();
            $.getJSON('/cart.js', function(cart){
              refreshCart(cart);
            });
            $('.productGrid .productItem').removeClass('qvopen');
            $('body').addClass('cartOpen');
            $('.fullPage').addClass('witmenu');
          }
        });
      });

    });
    $('.openQv').removeAttr('disabled');
  });
  /* Quick View */
});

$(window).scroll(function() {    
  var scroll = $(window).scrollTop();
  if($(window).width() < 992) {
    if(scroll > 10) {
      $(".Main-Header").addClass("darkHeader");
    } else {
      $(".Main-Header").removeClass("darkHeader");
    }
  }
});



/*$(window).scroll(function () {
  var w = window.innerWidth;
  if (w > 767) {
    $(".product-images").stick_in_parent({offset_top: 60});
    $("#scroller").stick_in_parent({recalc_every: 1});
    $(".cart-total").stick_in_parent({offset_top: 60});	
  }
});*/

$(window).on('load',function(){
  

  
});
